import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveView,
  setSchedulePaymentsDetails,
} from "../../../../_redux/_actions/schedulePayments.actions";
import { schedulePaymentsConstants } from "../../../../_redux/_constants";
import { UiMobileBottomCard } from "../../../_uiComponents/Dashboard/UiMobileBottomCard";
import { UiNavBar } from "../../../_uiComponents/UiNavbar";
import SchedulePaymentSummary from "./SchedulePaymentSummary";
import ScheduleIterationDetail from "./ScheduleIterationDetail";
import { UiSchedulePaymentsStop } from "../../../_uiComponents/SchedulePayments/UiSchedulePaymentsStop";
import { UiSchedulePaymentIterationStop } from "../../../_uiComponents/SchedulePayments/UiSchedulePaymentIterationStop";

export const SchedulePaymentDetails = () => {
  const dispatch = useDispatch();
  const activeView = useSelector((state) => state.schedulePayments.activeView);

  useEffect(() => {
    return () => {
      dispatch(setSchedulePaymentsDetails(null));
    };
  }, [dispatch]);

  const handleOkClick = () => {
    dispatch(setActiveView(null));
  };

  return (
    <>
      <UiNavBar />

      {activeView ===
        schedulePaymentsConstants.ACTIVE_VIEW_SCHEDULE_PAYMENT_SUMMARY && (
        <SchedulePaymentSummary />
      )}

      {activeView ===
        schedulePaymentsConstants.ACTIVE_VIEW_SCHEDULE_PAYMENT_ITERATION_DETAIL && (
        <ScheduleIterationDetail />
      )}

      {activeView ===
        schedulePaymentsConstants.ACTIVE_VIEW_SCHEDULE_PAYMENT_STOP_SUCCESS && (
        <UiSchedulePaymentsStop onOkClick={handleOkClick} />
      )}

      {activeView ===
        schedulePaymentsConstants.ACTIVE_VIEW_SCHEDULE_PAYMENT_ITERATION_STOP && (
        <UiSchedulePaymentIterationStop
          onOkClick={() =>
            dispatch(
              setActiveView(
                schedulePaymentsConstants.ACTIVE_VIEW_SCHEDULE_PAYMENT_SUMMARY,
              ),
            )
          }
        />
      )}

      <UiMobileBottomCard />
    </>
  );
};
